import sift from 'common/js_utils/sift';

export const getCurrentDomain = (): string =>
  sift(
    window,
    'serverConfig.domain', // Won't work if we're federated or not on vizcan/dslp (i.e., storyteller).
    'socrata.domain',
    'location.hostname', // Won't work if we're federated or looking at an alias.
  ) ?? '';
